<div class="ibox detailed-view-ibox" *ngIf="settingsPassOnLogService.showDetailedView">
    <div class="detailed-view-header">
        <div class="detailed-view-amenity-name">Pass On Log Settings</div>
        <div style="font-size: 15px;">
            {{settingsPassOnLogService.selectedItemData ? settingsPassOnLogService.selectedItemData.corporationNumberName : ''}}
        </div>
        <span class="close-detailed-view" (click)="settingsPassOnLogService.toggleDetailedView(null, false)">×</span>
    </div>
    <div>
        <div class="detailed-view-body">
            <div class="detailed-view__more-info m-t-md" *ngIf="settingsPassOnLogService.selectedItemData">
                <form #form="ngForm" submittable autocomplete="off">
                    <div>
                        <div class="detailed-view-navigation  btn-group btn-group-justified">
                            <div class="col-md-6 col-sm-6 col-xs-6 no-padding btn">
                                <div class="button-section"
                                     (click)="navPosition = 'general';"
                                     [ngStyle]="{'background-color': navPosition == 'general' ? '#ebebeb' : ''}">
                                    General
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-xs-6 no-padding btn">
                                <div class="button-section"
                                     (click)="navPosition = 'notifications';"
                                     [ngStyle]="{'background-color': navPosition == 'notifications' ? '#ebebeb' : ''}">
                                    Notifications
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="navPosition == 'general'">
                        <div class="slider-container m-t-sm m-b-xs">
                            <span>Show Pop Up On Dashboard</span>
                            <mat-slide-toggle name="showPopupUponDashboard"
                                              (change)="onSubmit({showPopupUponDashboard: {active: form.value.showPopupUponDashboard}})"
                                              [(ngModel)]="settingsPassOnLogService.selectedItemData.showPopupUponDashboard.active">
                            </mat-slide-toggle>
                        </div>
                        <div class="m-b-xs bold">User Roles</div>
                        <div class="m-b-xs" *ngIf="settingsPassOnLogService.selectedItemData.showPopupUponDashboard.active">
                            <multiselect-field name="popupRoles"
                                               [data]="settingsPassOnLogService.userRoles"
                                               [(ngModel)]="settingsPassOnLogService.selectedItemData.showPopupUponDashboard.roles"
                                               (update)="submitPopupRoles(form.value.popupRoles)">
                            </multiselect-field>
                        </div>
                    </div>
                    <div *ngIf="navPosition == 'notifications'">
                        <div class="text-center bold m-t-sm" style="color: red;">COMING SOON</div>
                        <!--<div class="settings-amenities-slider-container">-->
                            <!--<span>Notify Staff</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsPassOnLogService.passCreatedStaffCheckbox"-->
                                       <!--name="passCreatedStaffCheckbox" id="passCreatedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'created')"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="passCreatedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'created') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'created')">Pass On Log Created</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs" *ngIf="settingsPassOnLogService.passCreatedStaffCheckbox">-->
                            <!--<multiselect-field-->
                                <!--name="createdStaffMultiselectArray"-->
                                <!--[data]="settingsPassOnLogService.userRoles"-->
                                <!--[(ngModel)]="settingsPassOnLogService.createdStaffMultiselectArray"-->
                                <!--(update)="submitNotificationsField()">-->
                            <!--</multiselect-field>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsPassOnLogService.passReadStaffCheckbox"-->
                                       <!--name="passReadStaffCheckbox" id="passReadStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'read')"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="passReadStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'read') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'read')">Pass On Log Read</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs" *ngIf="settingsPassOnLogService.passReadStaffCheckbox">-->
                            <!--<multiselect-field-->
                                <!--name="readStaffMultiselectArray"-->
                                <!--[data]="settingsPassOnLogService.userRoles"-->
                                <!--[(ngModel)]="settingsPassOnLogService.readStaffMultiselectArray"-->
                                <!--(update)="submitNotificationsField()">-->
                            <!--</multiselect-field>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsPassOnLogService.passUpdatedStaffCheckbox"-->
                                       <!--name="passUpdatedStaffCheckbox" id="passUpdatedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'updated')"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="passUpdatedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'updated') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'updated')">Pass On Log Updated</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs" *ngIf="settingsPassOnLogService.passUpdatedStaffCheckbox">-->
                            <!--<multiselect-field-->
                                <!--name="updatedStaffMultiselectArray"-->
                                <!--[data]="settingsPassOnLogService.userRoles"-->
                                <!--[(ngModel)]="settingsPassOnLogService.updatedStaffMultiselectArray"-->
                                <!--(update)="submitNotificationsField()">-->
                            <!--</multiselect-field>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs filter-checkbox">-->
                            <!--<label class="img-checkbox">-->
                                <!--<input type="checkbox" [(ngModel)]="settingsPassOnLogService.passDeletedStaffCheckbox"-->
                                       <!--name="passDeletedStaffCheckbox" id="passDeletedStaffCheckbox"-->
                                       <!--[disabled]="!emailTemplateIsSet('staff', 'deleted')"-->
                                       <!--(change)="submitNotificationsField()">-->
                                <!--<label for="passDeletedStaffCheckbox"-->
                                       <!--[title]="!emailTemplateIsSet('staff', 'deleted') ? 'Please select email template first' : ''">-->
                                    <!--<svg-checked></svg-checked>-->
                                <!--</label>-->
                            <!--</label>-->
                            <!--<span class="mtv-primary-color clickable-text"-->
                                  <!--(click)="showNotificationModal('staff', 'deleted')">Pass On Log Deleted</span>-->
                        <!--</div>-->
                        <!--<div class="m-b-xs" *ngIf="settingsPassOnLogService.passDeletedStaffCheckbox">-->
                            <!--<multiselect-field-->
                                <!--name="deletedStaffMultiselectArray"-->
                                <!--[data]="settingsPassOnLogService.userRoles"-->
                                <!--[(ngModel)]="settingsPassOnLogService.deletedStaffMultiselectArray"-->
                                <!--(update)="submitNotificationsField()">-->
                            <!--</multiselect-field>-->
                        <!--</div>-->
                    </div>
                </form>
            </div>
            <div *ngIf="!settingsPassOnLogService.selectedItemData">
                <spinner [spinnerShow]="true"></spinner>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-pass-on-log/settings-pass-on-log-detailed-view/settings-pass-on-log-detailed-view.component.html